import * as React from 'react'

const SvgPhone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={73}
    height={120}
    viewBox="0 0 73 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Phone_svg__a)">
      <path
        d="M56.182 0H9.535C4.269 0 0 4.26 0 9.511V110.49C0 115.742 4.269 120 9.535 120h46.647c5.266 0 9.534-4.258 9.534-9.511V9.511c0-5.252-4.268-9.51-9.534-9.51Z"
        fill="#E1CEFF"
      />
      <path
        d="M18.672.909h41.329c6.43 0 11.653 5.21 11.653 11.625v94.864c0 6.414-5.222 11.624-11.653 11.624H18.672c-6.43 0-11.653-5.21-11.653-11.624V12.534C7.019 6.119 12.242.909 18.672.909Z"
        fill="#440A78"
      />
      <path
        d="M63.884 0h-48.66c-5.027 0-9.116 4.08-9.116 9.094V110.9c0 5.014 4.089 9.094 9.116 9.094h48.66c5.027 0 9.116-4.08 9.116-9.094V9.094C73 4.079 68.91 0 63.884 0Zm6.515 110.906c0 3.588-2.913 6.499-6.515 6.499h-48.66c-3.597 0-6.515-2.906-6.515-6.499V9.099c0-3.588 2.913-6.5 6.515-6.5H25.75c.852 0 1.541.688 1.541 1.538a3.037 3.037 0 0 0 3.04 3.033h18.44c1.68 0 3.04-1.358 3.04-3.033 0-.85.69-1.537 1.542-1.537h10.53c3.598 0 6.516 2.906 6.516 6.5v101.806Z"
        fill="#9865FC"
      />
      <path
        d="m24.425 109.162 35.756 1.85-35.756 1.849c-2.575.037-2.585-3.736 0-3.699Z"
        fill="#9865FC"
      />
      <path
        d="M59.958 17.015H19.891a3.174 3.174 0 0 0-3.179 3.17v5.38c0 1.75 1.423 3.17 3.179 3.17h40.067a3.174 3.174 0 0 0 3.179-3.17v-5.38a3.174 3.174 0 0 0-3.179-3.17Z"
        fill="#FFC103"
      />
    </g>
    <defs>
      <clipPath id="Phone_svg__a">
        <path fill="#fff" d="M0 0h73v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgPhone
